var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('classification',{attrs:{"classification":_vm.classification}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }